"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcludeCurrentPeriodToggle = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ExcludeCurrentPeriodToggleLabel_1 = require("./ExcludeCurrentPeriodToggleLabel");
var alignPoints = [{ align: "tc bc" }];
exports.ExcludeCurrentPeriodToggle = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled, granularity = _a.granularity;
    return (react_1.default.createElement("div", { className: "gd-extended-date-filter-exclude-current" },
        react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, null,
            react_1.default.createElement("label", { className: classnames_1.default("s-exclude-current-period", "input-checkbox-label", {
                    "s-exclude-current-perod-enabled": !disabled,
                    "s-exclude-current-perod-disabled": disabled,
                }) },
                react_1.default.createElement("input", { type: "checkbox", className: "input-checkbox", checked: value, onChange: function (e) { return onChange(e.target.checked); }, disabled: disabled }),
                "\u2002",
                react_1.default.createElement(ExcludeCurrentPeriodToggleLabel_1.ExcludeCurrentPeriodToggleLabel, { granularity: granularity, disabled: disabled })),
            disabled ? (react_1.default.createElement(sdk_ui_kit_1.Bubble, { alignPoints: alignPoints },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.excludeCurrentPeriod.unavailable" }))) : null)));
};
//# sourceMappingURL=ExcludeCurrentPeriodToggle.js.map